import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as p } from "./index.es2444.js";
function C(d) {
  const { outline: i, fill: t, size: l, innerElementFill: o } = p(d);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("g", { clipPath: "url(#clip0_260_3414)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.9575 12.416L17.2605 15.733C17.6805 16.152 17.6805 16.833 17.2605 17.252L17.2515 17.261C16.8325 17.68 16.1525 17.68 15.7335 17.261L12.4305 13.943",
              fill: t
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.6929 12.1503C13.8397 12.0041 14.0771 12.0046 14.2232 12.1514L17.5253 15.4675C18.0918 16.0331 18.0921 16.9521 17.5253 17.5175L17.5167 17.5262C16.9512 18.0916 16.0338 18.0916 15.4683 17.5262L12.1647 14.2076C12.0186 14.0608 12.0192 13.8233 12.1659 13.6772C12.3127 13.5311 12.5502 13.5317 12.6963 13.6784L15.9987 16.9958C16.2712 17.2681 16.7139 17.2683 16.9863 16.9958L16.9953 16.9868C17.2685 16.7144 17.2688 16.271 16.9957 15.9985L16.9948 15.9976L13.6918 12.6806C13.5456 12.5338 13.5461 12.2964 13.6929 12.1503Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.875 0.75C3.94007 0.75 0.75 3.93914 0.75 7.875C0.75 11.8109 3.94007 15 7.875 15C11.8099 15 15 11.8109 15 7.875C15 3.93914 11.8099 0.75 7.875 0.75ZM0 7.875C0 3.52486 3.52593 0 7.875 0C12.2241 0 15.75 3.52486 15.75 7.875C15.75 12.2251 12.2241 15.75 7.875 15.75C3.52593 15.75 0 12.2251 0 7.875Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.4986 4.25146C9.49708 2.24991 6.25252 2.24991 4.25097 4.25146C4.10452 4.39791 3.86708 4.39791 3.72063 4.25146C3.57419 4.10502 3.57419 3.86758 3.72063 3.72113C6.01508 1.42669 9.73452 1.42669 12.029 3.72113C12.1754 3.86758 12.1754 4.10502 12.029 4.25146C11.8825 4.39791 11.6451 4.39791 11.4986 4.25146Z",
              fill: i
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3414", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: o
          }
        ) }) })
      ]
    }
  );
}
C.__tags = [];
export {
  C as SearchIcon
};
//# sourceMappingURL=index.es342.js.map
